export default __webpack_public_path__ + "static/media/logo-nuol.63daaa1c.png";